import {memo} from 'react'

import PropTypes from 'prop-types'

import ListTagCloud from '@adv-mt/mt-list-tagcloud'
import Breadcrumb from '@adv-mt/mt-navigation-breadcrumb'

import LinkFactory from '../../../../../../components/LinkFactory/index.js'
import {BASE_CLASS as PAGE_BASE_CLASS} from '../../config.js'

const BASE_CLASS = `${PAGE_BASE_CLASS}-navigationFooter`

const NavigationFooter = ({ad = {}, breadcrumb = [], tagclouds = [], pageErrors = {}, pageName}) => {
  const hasTagclouds = Boolean(tagclouds.length)
  const hasBreadcrumb = Boolean(breadcrumb.length) && !pageErrors.breadcrumbError

  return (
    <div className={BASE_CLASS}>
      {hasTagclouds &&
        tagclouds.map((tagcloud, index) => (
          <ListTagCloud
            initialTagclouds={tagcloud}
            key={`${ad.makeId}-${index}`}
            linkFactory={LinkFactory}
            makeId={ad.makeId}
            modelId={ad.modelId}
            pageName={pageName}
          />
        ))}
      {hasBreadcrumb && (
        <Breadcrumb items={breadcrumb} linkFactory={LinkFactory} className={`${BASE_CLASS}-breadcrumbs`} />
      )}
    </div>
  )
}

NavigationFooter.displayName = 'NavigationFooter'
NavigationFooter.propTypes = {
  ad: PropTypes.object,
  breadcrumb: PropTypes.array,
  tagclouds: PropTypes.array,
  pageErrors: PropTypes.object,
  pageName: PropTypes.string
}

export default memo(NavigationFooter)
